export default function LEDStrip(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M23.9778 40.6899C33.2077 40.6899 40.6899 33.2077 40.6899 23.9778C40.6899 14.7479 33.2077 7.26562 23.9778 7.26562C14.7479 7.26562 7.26562 14.7479 7.26562 23.9778C7.26562 33.2077 14.7479 40.6899 23.9778 40.6899Z"
                stroke="white"
                strokeWidth="2.38745"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.9424 34.1836C29.5995 34.1836 34.1856 29.5976 34.1856 23.9404C34.1856 18.2833 29.5995 13.6973 23.9424 13.6973C18.2852 13.6973 13.6992 18.2833 13.6992 23.9404C13.6992 29.5976 18.2852 34.1836 23.9424 34.1836Z"
                stroke="white"
                strokeWidth="2.38745"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.998 27.3945C25.9386 27.3945 27.5117 25.8481 27.5117 23.9404C27.5117 22.0328 25.9386 20.4863 23.998 20.4863C22.0575 20.4863 20.4844 22.0328 20.4844 23.9404C20.4844 25.8481 22.0575 27.3945 23.998 27.3945Z"
                stroke="white"
                strokeWidth="2.38745"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M42.0586 36.75V36.75C40.1316 39.2961 37.123 40.7922 33.9299 40.7922H24.0586"
                stroke="white"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
